import * as actions from '@xmatters/redux/actions/countries';

const defaultState = {
  data: [],
  status: 'NOT_LOADED',
};

export default function countries(state = defaultState, action) {
  switch (action.type) {
    case actions.GET_USED_COUNTRIES_START:
      return {
        ...state,
        status: 'LOADING',
      };
    case actions.GET_USED_COUNTRIES_FAIL:
      return {
        ...state,
        data: [],
        status: 'FAILED',
      };
    case actions.GET_USED_COUNTRIES_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        status: 'LOADED',
      };
    default:
      return state;
  }
}
